import '@fancyapps/fancybox';
import 'bootstrap';
import imagesLoaded from 'imagesloaded';
import $ from 'jquery';
import Masonry from 'masonry-layout';
import jQueryBridget from 'jquery-bridget';
import 'select2/dist/js/select2.full';
import 'select2/dist/js/i18n/ru';
import 'jquery-ui/ui/i18n/datepicker-ru';
import 'slick-carousel';

import './components/hs.carousel';
import './components/hs.counter';
import './components/hs.cubeportfolio';
import './components/hs.file-attachement';
import './components/hs.datepicker-1.0';
import './components/hs.slider';
import './components/hs.go-to';
import './components/hs.header';
import './components/hs.select';
import './components/hs.sticky-block';
import './components/hs.tabs';
import './components/hs.modal-window';
import './components/hs.dropdown';

import './helpers/hs.focus-state';
import './helpers/hs.hamburgers';

import './vendors/hs.megamenu';

import init from './map';

//переносим из внешних файлов
import './add/adds';
//import './add/lib';
//import './add/md5.min';

var md5 = require ('./add/md5.min');


jQueryBridget('masonry', Masonry, $);
jQueryBridget('imagesLoaded', imagesLoaded, $);

$.fn.select2.defaults.set('language', 'ru');
$.fn.select2.defaults.set('theme', 'bootstrap4');
$.fn.select2.defaults.set('width', 'style');

$(() => {

    "use strict";
    function rounded(number, prec) {
        return +number.toFixed(prec);
    }

    function generateRandomKeyMd5() {
        var t = new Date();
        var key = Math.random() + ' ' + t.getTime();
        key = md5(key);
        return key;
    }

    function correctNumberInput(val) {
        if (val.match(/[,]/g)) {
            val = val.replace(/[,]/g, '.');
        }
        if (val.match(/[^0-9.]/g)) {
            val = val.replace(/[^0-9.]/g, '');
        }
        return val;
    }

    window.generateRandomKeyMd5 = generateRandomKeyMd5;
    window.correctNumberInput = correctNumberInput;
    window.rounded = rounded;
    window.md5 = md5;

  $.HSCore.components.HSGoTo.init('.js-go-to');
  // initialization of counters
  $.HSCore.components.HSCounter.init('[class*="js-counter"]',{'time': 2000});
  $.HSCore.components.HSCarousel.init('.js-carousel');
  $.HSCore.components.HSTabs.init(
    '[role="tablist"]',
  );

  // initialization of forms
  $.HSCore.components.HSFileAttachment.init('.js-file-attachment');
  $.HSCore.components.HSFileAttachment.init('.kml-file-attachment', {
    changeInput: `
    <div class="u-file-attach-v3 g-mb-15">
        <h3 class="g-font-size-16 g-color-gray-dark-v2 mb-0"><span class="g-color-primary">Перетащите KML файл сюда</span></h3>
    </div>
    `,
  });

  $.HSCore.components.HSFileAttachment.init('.archive-file-attachment');

    // initialization of HSDropdown component
    $.HSCore.components.HSDropdown.init($('[data-dropdown-target]'), {
        afterOpen: function () {
            $(this).find('input[type="search"]').focus();
        }
    });

});

// Init organization tab
const initOrganizationTab = () => {
  $.HSCore.components.HSCarousel.init('.finish-register-org');

  $('#finish-register-org')
    .slick('setOption', 'customPaging', (slider, i) => {
      const title = $(slider.$slides[i])
        .data('title');

      return `<i class="u-dot-line-v1 g-brd-gray-light-v2--before g-brd-gray-light-v2--after g-mb-15--sm"><span class="u-dot-line-v1__inner g-bg-white g-bg-primary--before g-brd-gray-light-v2 g-brd-primary--active g-transition--ease-in g-transition-0_2"></span></i><span class="g-hidden-sm-down g-color-black g-font-size-15">${title}</span>`;
    }, true);

  $('body')
    .on('click', '.next-step, .finish-register-btn', function () {
      $(this)
        .closest('.tab-pane.active')
        .find('.js-pagination .slick-active')
        .addClass('dot-step-complete');
    });

  $('body')
    .on('click', '.next-step, .skip-step', () => {
      $('#finish-register-org')
        .slick('slickNext');
    });

  $('body')
    .on('click', '.finish-register-btn', (e) => {
      e.preventDefault();
    });

  // Organization fields
  $('#company-scope')
    .select2({
      tags: true,
      placeholder: 'Введите сферы деятельности',
      dropdownCssClass: 'd-none',
    });

  $('#phone-general')
    .select2({
      tags: true,
      placeholder: '+7',
      dropdownCssClass: 'd-none',
    });

  $('#drilling-rigs')
    .select2({
      tags: true,
      placeholder: 'Введите наименования',
      dropdownCssClass: 'd-none',
    });

  $('#working-regions')
    .select2({
      tags: true,
      placeholder: 'Название региона',
      dropdownCssClass: 'd-none',
    });

  let staffFieldsId = 1;

  const select2StaffPhoneOptions = {
    tags: true,
    placeholder: 'Введите как минимум один телефон',
    dropdownCssClass: 'd-none',
  };

  $('.staff-phone')
    .select2(select2StaffPhoneOptions);

  // eslint-disable-next-line func-names
  const addStuffFields = function () {
    staffFieldsId += 1;

    $('.staff-phone')
      .select2('destroy');

    $('.staff-block:first')
      .clone()
      .find('input')
      .val('')
      .end()
      .find('label[for^="fio-staff-"]')
      .prop('for', `fio-staff-${staffFieldsId}`)
      .end()
      .find('input[id^="fio-staff-"]')
      .prop('id', `fio-staff-${staffFieldsId}`)
      .end()
      .find('label[for^="position-"]')
      .prop('for', `position-${staffFieldsId}`)
      .end()
      .find('input[id^="position-"]')
      .prop('id', `position-${staffFieldsId}`)
      .end()
      .find('label[for^="note-"]')
      .prop('for', `note-${staffFieldsId}`)
      .end()
      .find('textarea')
      .prop('id', `note-${staffFieldsId}`)
      .val('')
      .end()
      .find('.staff-phone')
      .prop('id', `staff-phone-${staffFieldsId}`)
      .prop('name', `staff-phone-${staffFieldsId}`)
      .end()
      .find('label[for^="staff-phone-"]')
      .prop('for', `staff-phone-${staffFieldsId}`)
      .end()
      .appendTo('.staff-block-wrap');

    $('.staff-phone')
      // eslint-disable-next-line func-names
      .each(function () {
        $(this)
          .select2(select2StaffPhoneOptions);
      });
  };

  $('.add-stuff')
    .on('click', addStuffFields);
};

// Init individuals tab
const initIndividualsTab = () => {
  $.HSCore.components.HSCarousel.init('.finish-register-ind');

  $('#finish-register-ind')
    .slick('setOption', 'customPaging', (slider, i) => {
      const title = $(slider.$slides[i])
        .data('title');

      return `<i class="u-dot-line-v1 g-brd-gray-light-v2--before g-brd-gray-light-v2--after g-mb-15--sm"><span class="u-dot-line-v1__inner g-bg-white g-bg-primary--before g-brd-gray-light-v2 g-brd-primary--active g-transition--ease-in g-transition-0_2"></span></i><span class="g-hidden-sm-down g-color-black g-font-size-15">${title}</span>`;
    }, true);

  $('body')
    .on('click', '.next-step, .skip-step', () => {
      $('#finish-register-ind')
        .slick('slickNext');
    });

  // Individuals fields
  $('#phone-ind')
    .select2({
      tags: true,
      placeholder: 'Введите как минимум один телефон',
      dropdownCssClass: 'd-none',
    });

  $('#region-ind')
    .select2({
      placeholder: 'Выберите регион работы',
    });
};

// Init new service tab
const initServiceStepper = () => {
  $.HSCore.components.HSCarousel.init('.new-service-stepper');

  $('#new-service-stepper')
    .slick('setOption', 'customPaging', (slider, i) => {
      const title = $(slider.$slides[i])
        .data('title');

      return `<i class="u-dot-line-v1 g-brd-gray-light-v2--before g-brd-gray-light-v2--after g-mb-15--sm"><span class="u-dot-line-v1__inner g-bg-white g-bg-primary--before g-brd-gray-light-v2 g-brd-primary--active g-transition--ease-in g-transition-0_2"></span></i><span class="g-hidden-sm-down g-color-black g-font-size-15">${title}</span>`;
    }, true);

  $('body')
    .on('click', '.next-step, .finish-register-btn', function () {
      $(this)
        .closest('.slick-slider')
        .find('.js-pagination .slick-active')
        .addClass('dot-step-complete');
    });

  $('body')
    .on('click', '.next-step, .skip-step', () => {
      $('#new-service-stepper')
        .slick('slickNext');
    });

  $('body')
    .on('click', '.finish-register-btn', (e) => {
      e.preventDefault();
    });

  // Organization fields
  $('#service-category')
    .select2({
      placeholder: 'Выберите категорию',
    });

  $('#service-subcategory')
    .select2({
      placeholder: 'Выберите подкатегорию',
    });

  $('#service-contact')
    .select2({});

  $('#service-working-regions')
    .select2({
      tags: true,
      placeholder: 'Выберите регион',
      createTag() {
        return undefined;
      },
    });
};

// Init new tender stepper
const initTenderStepper = () => {
  $.HSCore.components.HSCarousel.init('.new-tender-stepper');

  $('#new-tender-stepper')
    .slick('setOption', 'customPaging', (slider, i) => {
      const title = $(slider.$slides[i])
        .data('title');

      return `<i class="u-dot-line-v1 g-brd-gray-light-v2--before g-brd-gray-light-v2--after g-mb-15--sm"><span class="u-dot-line-v1__inner g-bg-white g-bg-primary--before g-brd-gray-light-v2 g-brd-primary--active g-transition--ease-in g-transition-0_2"></span></i><span class="g-hidden-sm-down g-color-black g-font-size-15">${title}</span>`;
    }, true);

  $('body')
    .on('click', '.next-step, .finish-register-btn', function () {
      $(this)
        .closest('.slick-slider')
        .find('.js-pagination .slick-active')
        .addClass('dot-step-complete');
    });

  $('body')
    .on('click', '.next-step, .skip-step', () => {
      $('#new-tender-stepper')
        .slick('slickNext');
    });

  $('body')
    .on('click', '.finish-register-btn', (e) => {
      e.preventDefault();
    });

  // Organization fields
  $('#tender-category')
    .select2({
      placeholder: 'Выберите категорию',
    });

  $('#tender-subcategory')
    .select2({
      placeholder: 'Выберите подкатегорию',
    });

  $('#tender-working-regions')
    .select2({
      tags: true,
      placeholder: 'Выберите регион',
      createTag() {
        return undefined;
      },
    });
};

// Init new archive stepper
const initArchiveStepper = () => {
  $.HSCore.components.HSCarousel.init('.new-archive-stepper');

  $('#new-archive-stepper')
    .slick('setOption', 'customPaging', (slider, i) => {
      const title = $(slider.$slides[i])
        .data('title');

      return `<i class="u-dot-line-v1 g-brd-gray-light-v2--before g-brd-gray-light-v2--after g-mb-15--sm"><span class="u-dot-line-v1__inner g-bg-white g-bg-primary--before g-brd-gray-light-v2 g-brd-primary--active g-transition--ease-in g-transition-0_2"></span></i><span class="g-hidden-sm-down g-color-black g-font-size-15">${title}</span>`;
    }, true);

  $('body')
    .on('click', '.next-step, .finish-register-btn', function () {
      $(this)
        .closest('.slick-slider')
        .find('.js-pagination .slick-active')
        .addClass('dot-step-complete');
    });

  $('body')
    .on('click', '.next-step, .skip-step', () => {
      $('#new-archive-stepper')
        .slick('slickNext');
    });

  $('body')
    .on('click', '.finish-register-btn', (e) => {
      e.preventDefault();
    });
};

// New Archive
$('#research-select')
  .select2({
    placeholder: 'Выберите тип изысканий',
  });

$('#report-volume')
  .select2({
    placeholder: 'Выберите объем отчета',
  });

// Init responses modal

// eslint-disable-next-line func-names
const reactToResponse = function () {
  $('.modal').modal('hide');
};

$('body').on('click', '.react-to-response', reactToResponse);

/*
const initAuthBlockToggle = () => {
  $('body').on('click', '.auth-block-item', function(e) {
    if (e.target.closest('.dropdown-item, .dropdown-toggle')) {
      return;
    }
    $(this).removeClass('d-flex').addClass('d-none');
    $(this).siblings().addClass('d-flex').removeClass('d-none');
  });
};

initAuthBlockToggle();
*/

$(window)
  .on('load', () => {
    initOrganizationTab();
    initIndividualsTab();
    initServiceStepper();
    initTenderStepper();
    initArchiveStepper();

    // initialization of cubeportfolio
    $.HSCore.components.HSCubeportfolio.init('.cbp');
    $.HSCore.components.HSHeader.init($('#js-header'));
    $.HSCore.helpers.HSHamburgers.init('.hamburger');
    $('.js-mega-menu')
      .HSMegaMenu({
        event: 'hover',
        pageContainer: $('.container'),
        breakpoint: 991,
      });

    // initialization of custom select
    setTimeout(() => { // important in this case
      $.HSCore.components.HSSelect.init('.js-custom-select');

      const masonryGrid = document.querySelector('.masonry-grid');
      if (masonryGrid !== null) {
        imagesLoaded(
          masonryGrid,
          new Masonry(document.querySelector('.masonry-grid'), {
            columnWidth: '.masonry-grid-sizer',
            itemSelector: '.masonry-grid-item',
            percentPosition: true,
          }),
        );
      }
    }, 1);

    $.HSCore.components.HSStickyBlock.init('.js-sticky-block');
    $('body')
      .on('click', 'a[href="#companies"]', () => {
        setTimeout(() => {
          $.HSCore.components.HSStickyBlock.init('.js-sticky-block-2');
        }, 200);
      });
  });

// if ($('[role="tablist"]').length > 0) {
//   $(window)
//     .on('resize', () => {
//       setTimeout(() => {
//         $.HSCore.components.HSTabs.init(
//           '[role="tablist"]',
//         );
//       }, 200);
//     });
// }

$(() => {
  // $.HSCore.components.HSDatepicker.init('#js-datepicker-from');
  // $.HSCore.components.HSSlider.init('#drillingDepthSlider');
  $.HSCore.components.HSDatepicker.init('#tender-date');
  $.HSCore.components.HSDatepicker.init('#archive-date');
  $.HSCore.components.HSDatepicker.init('#Archive_date_research_edit',{yearRange:"-100:null"});
  $.HSCore.components.HSDatepicker.init('#Tender_deadline_edit',{yearRange:"null:+50"});


});

$(window)
  .on('load', () => {
    $('#archives-search')
      .select2({
        placeholder: 'По названию/владельцу',
        minimumInputLength: 3,
        // ajax: {
        //   delay: 250,
        //   url: 'https://jsonplaceholder.typicode.com/users',
        //   dataType: 'json',
        // },
      });
  });


// new-response rating
document.addEventListener(
  'submit',
  (event) => {
    if (!event.target.matches('.rating')) return;

    event.preventDefault();

    const selected = document.activeElement;
    if (!selected) return;
    const selectedIndex = parseInt(selected.getAttribute('data-star'), 10);
    console.debug(`rate is ${selectedIndex}`);

    const stars = Array.from(event.target.querySelectorAll('.star'));

    stars.forEach((star, index) => {
      if (index < selectedIndex) {
        star.classList.add('selected');
      } else {
        star.classList.remove('selected');
      }
    });

    const previousRating = event.target.querySelector(
      '.star[aria-pressed="true"]',
    );
    if (previousRating) {
      previousRating.removeAttribute('aria-pressed');
    }

    selected.setAttribute('aria-pressed', true);
  },
  false,
);

const highlight = function (event) {
  if (!event.target.closest) return;
  const star = event.target.closest('.star');
  const form = event.target.closest('.rating');
  if (!star || !form) return;

  const selectedIndex = parseInt(star.getAttribute('data-star'), 10);

  const stars = Array.from(form.querySelectorAll('.star'));

  stars.forEach((star, index) => {
    if (index < selectedIndex) {
      star.classList.add('selected');
    } else {
      star.classList.remove('selected');
    }
  });
};

document.addEventListener('mouseover', highlight, false);
document.addEventListener('focus', highlight, true);

const resetSelected = function (event) {
  if (!event.target.closest) return;
  const form = event.target.closest('.rating');
  if (!form) return;

  const stars = Array.from(form.querySelectorAll('.star'));

  const selected = form.querySelector('.star[aria-pressed="true"]');
  const selectedIndex = selected
    ? parseInt(selected.getAttribute('data-star'), 10)
    : 0;

  stars.forEach((star, index) => {
    if (index < selectedIndex) {
      star.classList.add('selected');
    } else {
      star.classList.remove('selected');
    }
  });
};

document.addEventListener('mouseleave', resetSelected, true);
document.addEventListener('blur', resetSelected, true);

// @route('/services/new') - multi-select
const createShowSubcategoryButton = () => {
  const subcategoryButton = document.createElement('button');

  subcategoryButton.setAttribute('class', 'btn btn-md u-btn-primary g-mb-15 text-uppercase g-font-size-13 g-font-weight-600');
  subcategoryButton.setAttribute('type', 'button');
  subcategoryButton.setAttribute('id', 'show-subcategory-button');
  subcategoryButton.innerHTML = 'Рендер подкатегорий';

  document.body.append(subcategoryButton);
};

const destroyShowSubcategoryButton = () => {
  const subcategoryButton = document.getElementById('show-subcategory-button');

  if (subcategoryButton) {
    subcategoryButton.remove();
  }
};

const makeCategoryList = (categories) => {
  const copiedCategories = JSON.parse(JSON.stringify(categories)); // copy without reference
  const listCategories = [];
  for (const element in copiedCategories) {
    const category = copiedCategories[element];
    category.children = category.children_category;
    delete category.children_category;
    listCategories.push(category);
  }
  return listCategories;
};

function findNodeById(nodes, id) {
  let res;

  function findNode(nodes, id) {
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].id === id) {
        res = nodes[i];
        break;
      }
      if (nodes[i].children_category) {
        findNode(nodes[i].children_category, id);
      }
    }
  }

  findNode(nodes, id);

  if (res.children_category.length === 0) {
    res.text += ' - нет подкатегорий';
  } else {
    res.text += ' - подкатегории';
  }

  return res;
}

const renderOptions = (options) => {
  for (const element in options) {
    const option = new Option(options[element], options[element], true, true);
    option.setAttribute('disabled', 'disabled');
    $('#select-category').append(option).trigger('change');
  }
};

const selectionChoiceRemoveAboveFirst = () => {
  const choices = document.querySelectorAll('.select2-selection__choice__remove');
  choices.forEach((item, i) => {
    if (i !== 0) {
      item.style.display = 'none';
    }
  });
};

const remakeTempBadges = (e) => {
  tempBadges = [];
  for (const el in e.target.selectedOptions) {
    if (typeof e.target.selectedOptions[el] === 'object') {
      tempBadges.push(e.target.selectedOptions[el].text);
    }
  }
};

const rerenderCategories = (e, options) => {
  remakeTempBadges(e);
  tempCategories = makeCategoryList(makeNewCategoryList(options));
  $('#select-category').select2('destroy').empty().select2({
    closeOnSelect: false,
    data: tempCategories,
  });
  renderOptions(tempBadges);
};

const categories = [{
  id: '1',
  text: 'подкатегория 1',
  children_category: [{
    id: '4',
    text: 'буровые работы на суше',
    children_category: [],
  }],
},
{
  id: '2',
  text: 'подкатегория 2',
  children_category: [{
    id: '5',
    text: 'буровые работы на акватории',
    children_category: [],
  }],
},
{
  id: '3',
  text: 'подкатегория 3',
  children_category: [{
    id: '6',
    text: 'полевые работы',
    children_category: [{
      id: '7',
      text: 'зондирование динамическое',
      children_category: [],
    },
    {
      id: '8',
      text: 'зондирование статическое',
      children_category: [],
    },
    {
      id: '9',
      text: 'прессиометрия по глинистым грунтам',
      children_category: [],
    },
    {
      id: '10',
      text: 'прессиометрия по скальным грунтам',
      children_category: [],
    },
    {
      id: '11',
      text: 'испытания с применением штампа плоского',
      children_category: [{
        id: '14',
        text: 'I - с плоской подошвой площадью 2500см',
        children_category: [],
      },
      {
        id: '15',
        text: 'II - с плоской подошвой площадью 5000см',
        children_category: [],
      },
      {
        id: '16',
        text: 'III - с плоской подошвой площадью 600см',
        children_category: [],
      },
      ],
    },
    {
      id: '12',
      text: 'испытания с применением штампа винтового',
      children_category: [{
        id: '17',
        text: 'IV винтовой штамп площадью 600 см',
        children_category: [],
      }],
    },
    {
      id: '13',
      text: 'испытания с применением штампа горячего',
      children_category: [],
    },
    ],
  }],
},
];

let isFirstStep = true;
var tempCategories = makeCategoryList(categories);
var tempBadges = [];

const makeNewCategoryList = (categoriesId) => {
  const result = [];
  for (const element in categoriesId) {
    const categoryId = categoriesId[element];
    result.push(findNodeById(categories, categoryId));
  }

  return result;
};

/** Для сео-текстов*/
$('#seo_text_link').on('click', (e) => {
    $('.spoiler-text-description').toggleClass('hide');
    $('.seo-text').toggleClass('show');
});

$('#select-category').select2({
  closeOnSelect: true,
  placeholder: 'Выберите подкатегории',
  width: '100%',
  data: tempCategories,
});

$('#select-category').on('select2:select', (e) => {
  let optionsId = [];
  optionsId = $('#select-category').val();
  if (e.currentTarget.selectedOptions.length === 1 && isFirstStep === true) {
    rerenderCategories(e, optionsId);
    $('#select-category').select2('open');
    isFirstStep = false;
  }

  const subcategoryButton = document.getElementById('show-subcategory-button');

  if (e.currentTarget.selectedOptions.length === 2 && subcategoryButton === null && isFirstStep === false) {
    createShowSubcategoryButton();
  }
});

$('#select-category').on('select2:unselect', (e) => {
  if (e.currentTarget.selectedOptions.length === 0) {
    destroyShowSubcategoryButton();
    tempCategories = makeCategoryList(categories);
    $('#select-category').select2('destroy').empty().select2({
      closeOnSelect: false,
      placeholder: 'Выберите подкатегории',
      data: tempCategories,
    });
  }
  console.log(e.currentTarget.selectedOptions.length);
});

$('#select-category').on('change', (e) => {
  let optionsId = [];
  optionsId = $('#select-category').val();

  $('#show-subcategory-button').ready(() => {
    const subcategoryButton = document.getElementById('show-subcategory-button');
    if (subcategoryButton) {
      subcategoryButton.onclick = function () {
        rerenderCategories(e, optionsId);
      };
    }
  });
});

// route('archive') - show archive block
// if (window.location.pathname === '/archives') {
//   const renderCancelArchiveButton = (id) => {
//     const cancelArchiveButton = document.createElement('button');
//     cancelArchiveButton.setAttribute('id', 'cancel-new-archive-button');
//     cancelArchiveButton.setAttribute('class', 'btn btn-md u-btn-primary g-mr-10 g-mb-15 g-font-size-13 g-font-weight-600');
//     cancelArchiveButton.textContent = 'Отмена';
//     document.getElementById(id).append(cancelArchiveButton);
//
//     return cancelArchiveButton;
//   };
//
//   const removeCancelArchiveButton = () => {
//     const cancelArchiveButton = document.getElementById('cancel-new-archive-button');
//     cancelArchiveButton.remove();
//   };
//
//   const renderCreateArchiveButton = (id) => {
//     const createArchiveButton = document.createElement('button');
//     createArchiveButton.setAttribute('id', 'create-new-archive-button');
//     createArchiveButton.setAttribute('class', 'btn btn-md u-btn-primary g-mr-10 g-mb-15 g-font-size-13 g-font-weight-600');
//     createArchiveButton.textContent = 'Разместить архив';
//     document.getElementById(id).append(createArchiveButton);
//
//     return createArchiveButton;
//   };
//
//   const renderPrevStepButton = (classname, selector) => {
//     const prevStepButton = document.createElement('button');
//     prevStepButton.setAttribute('class', classname.split('.')[1]);
//     prevStepButton.textContent = '<< Назад';
//     document.querySelector(selector).append(prevStepButton);
//
//     return prevStepButton;
//   };
//
//   const renderNextStepButton = (classname, selector) => {
//     const nextStepButton = document.createElement('button');
//     nextStepButton.setAttribute('class', `next-step btn btn-md u-btn-primary g-mb-15 text-uppercase g-font-size-13 g-font-weight-600 step-counter next-step-button ${classname.split('.')[1]}`);
//     nextStepButton.setAttribute('type', 'button');
//     nextStepButton.textContent = 'Продолжить';
//
//     document.querySelector(selector).append(nextStepButton);
//
//     return nextStepButton;
//   };
//
//   const removeCreateArchiveButton = () => {
//     const createArchiveButton = document.getElementById('create-new-archive-button');
//     createArchiveButton.remove();
//   };
//
//   const showCreateArchive = () => {
//     document.getElementById('sidebar-search').style.display = 'none';
//     document.getElementById('sidebar-file-upload').style.display = 'block';
//     document.getElementById('map').style.display = 'none';
//     document.getElementById('create-new-archive').style.display = 'block';
//   };
//
//   const hideCreateArchive = () => {
//     document.getElementById('sidebar-search').style.display = 'block';
//     document.getElementById('sidebar-file-upload').style.display = 'none';
//     document.getElementById('map').style.display = 'block';
//     document.getElementById('create-new-archive').style.display = 'none';
//
//     removeCancelArchiveButton();
//     removeCreateArchiveButton();
//
//     dotTypeButton.classList.remove('active');
//     linearTypeButton.classList.remove('active');
//     areaTypeButton.classList.remove('active');
//
//     document.getElementById('create-new-archive__dot-object').style.display = 'none';
//     document.getElementById('create-new-archive__linear-object').style.display = 'none';
//     document.getElementById('create-new-archive__area-object').style.display = 'none';
//   };
//
//   let dotTypeButton = document.getElementById('dot-type-button');
//   dotTypeButton.onclick = function () {
//     targetProxy.typeOfArchive = this.textContent.trim();
//   };
//
//   let linearTypeButton = document.getElementById('linear-type-button');
//   linearTypeButton.onclick = function () {
//     targetProxy.typeOfArchive = this.textContent.trim();
//   };
//
//   let areaTypeButton = document.getElementById('area-type-button');
//   areaTypeButton.onclick = function () {
//     targetProxy.typeOfArchive = this.textContent.trim();
//   };
//
//   const showArchiveButton = document.getElementById('show-new-archive-button');
//   showArchiveButton.onclick = () => {
//     showCreateArchive();
//   };
//
//   const data = {
//     isDisabledCreateArchiveButton: true,
//     typeOfArchive: '',
//     typeOfArchiveStep: 0,
//   };
//
//   const targetProxy = new Proxy(data, {
//     set(target, key, value) {
//       target[key] = value;
//       if (key === 'typeOfArchive') {
//         if (value === 'Точка') {
//           document.getElementById('create-new-archive__dot-object').style.display = 'block';
//           document.getElementById('create-new-archive__linear-object').style.display = 'none';
//           document.getElementById('create-new-archive__area-object').style.display = 'none';
//
//           const cancelArchiveButton = document.getElementById('cancel-new-archive-button');
//           const createArchiveButton = document.getElementById('create-new-archive-button');
//
//           if (cancelArchiveButton !== null && createArchiveButton !== null) {
//             removeCancelArchiveButton();
//             removeCreateArchiveButton();
//           }
//
//           let prevStepFirstButton = document.querySelector('.action-button-prev-step-1');
//           let nextStepFirstButton = document.querySelector('.action-button-next-step-1');
//
//           let prevStepSecondButton = document.querySelector('.action-button-prev-step-2');
//           let nextStepSecondButton = document.querySelector('.action-button-next-step-2');
//
//           let prevStepThirdButton = document.querySelector('.action-button-prev-step-3');
//           let nextStepThirdButton = document.querySelector('.action-button-next-step-3');
//
//           let prevStepFourthButton = document.querySelector('.action-button-prev-step-4');
//           let nextStepFourthButton = document.querySelector('.action-button-next-step-4');
//
//           if (prevStepFirstButton === null && nextStepFirstButton === null) {
//             prevStepFirstButton = renderPrevStepButton('.action-button-prev-step-1', '.actions-buttons-step-1');
//             nextStepFirstButton = renderNextStepButton('.action-button-next-step-1', '.actions-buttons-step-1');
//           }
//
//           if (prevStepSecondButton === null && nextStepSecondButton === null) {
//             prevStepSecondButton = renderPrevStepButton('.action-button-prev-step-2', '.actions-buttons-step-2');
//             nextStepSecondButton = renderNextStepButton('.action-button-next-step-2', '.actions-buttons-step-2');
//           }
//
//           if (prevStepThirdButton === null && nextStepThirdButton === null) {
//             prevStepThirdButton = renderPrevStepButton('.action-button-prev-step-3', '.actions-buttons-step-3');
//             nextStepThirdButton = renderNextStepButton('.action-button-next-step-3', '.actions-buttons-step-3');
//           }
//
//           if (prevStepFourthButton === null && nextStepFourthButton === null) {
//             prevStepFourthButton = renderPrevStepButton('.action-button-prev-step-4', '.actions-buttons-step-4');
//             nextStepFourthButton = renderNextStepButton('.action-button-next-step-4', '.actions-buttons-step-4');
//           }
//
//           prevStepFirstButton.onclick = () => {
//             console.log('prev 1');
//           };
//
//           nextStepFirstButton.onclick = () => {
//             console.log('next 1');
//           };
//
//           prevStepSecondButton.onclick = () => {
//             console.log('prev 2');
//           };
//
//           nextStepSecondButton.onclick = () => {
//             console.log('next 2');
//           };
//
//           prevStepThirdButton.onclick = () => {
//             console.log('prev 3');
//           };
//
//           nextStepThirdButton.onclick = () => {
//             console.log('next 3');
//           };
//
//           prevStepFourthButton.onclick = () => {
//             console.log('prev 4');
//           };
//
//           nextStepFourthButton.onclick = () => {
//             console.log('next 4');
//           };
//         }
//
//         if (value === 'Линейный объект') {
//           document.getElementById('create-new-archive__dot-object').style.display = 'none';
//           document.getElementById('create-new-archive__linear-object').style.display = 'block';
//           document.getElementById('create-new-archive__area-object').style.display = 'none';
//         }
//
//         if (value === 'Площадной объект') {
//           document.getElementById('create-new-archive__dot-object').style.display = 'none';
//           document.getElementById('create-new-archive__linear-object').style.display = 'none';
//           document.getElementById('create-new-archive__area-object').style.display = 'block';
//         }
//       }
//       if (target.typeOfArchive === 'Линейный объект') {
//         let cancelArchiveButton = document.getElementById('cancel-new-archive-button');
//
//         if (cancelArchiveButton === null) {
//           cancelArchiveButton = renderCancelArchiveButton('create-new-archive__button-create-new');
//         }
//
//         cancelArchiveButton.onclick = () => {
//           hideCreateArchive();
//         };
//
//         let createArchiveButton = document.getElementById('create-new-archive-button');
//
//         if (createArchiveButton === null) {
//           createArchiveButton = renderCreateArchiveButton('create-new-archive__button-create-new');
//         }
//
//         createArchiveButton.onclick = () => {
//           hideCreateArchive();
//
//           console.log(data);
//         };
//       }
//       return true;
//     },
//   });
// }
//
// if (window.location.pathname === '/profile/subscriptions') {
//   const renderAlert = (classname, subscriptionState) => {
//     const div = document.createElement('div');
//
//     div.innerHTML = `<div
//         class="alert ${classname} alert-dismissible fade show alert-subscription"
//         role="alert"
//     >
//         <button
//             type="button"
//             class="close"
//             data-dismiss="alert"
//             aria-label="Close"
//         >
//             <span aria-hidden="true">×</span>
//         </button>
//         <strong>${subscriptionState.header}</strong>
//         ${subscriptionState.description}
//     </div>`;
//     document.querySelector('.alert-wrapper').append(div);
//   };
//
//   renderAlert('alert-success', {
//     header: 'Текущая подписка',
//     description: 'Месяц доступа активен до 24.02.2020',
//   });
//   renderAlert('alert-danger', {
//     header: 'Подписка закончилась.',
//     description: 'Годовой доступ закончился 14.01.2020',
//   });
// }

const removeClonedNode = function () {
  $(this).closest('.cloned').remove();
};

let clonedCount = 0;

const cloneNode = function () {
  clonedCount += 1;
  const target = $(this).data('copy');
  const $clonedNode = $(target).first().clone();

  $clonedNode.addClass('cloned');
  $clonedNode.find('label').each((i, el) => {
    $(el).attr('for', `${$(el).attr('for')}-${clonedCount}`);
    $(el).text('Телефон');
  });

  $clonedNode.find('input').each((i, el) => {
    $(el).val('');
    $(el).attr('placeholder', 'Введите дополнительный телефон');
    $(el).removeAttr('required');
    $(el).attr('id', `${$(el).attr('id')}-${clonedCount}`);
    $(el).after(`
    <div class="input-group-append delete">
      <span class="input-group-text g-bg-pink g-color-white g-brd-pink px-3 g-cursor-pointer">
      <i class="fas fa-trash"></i>
      </span>
    </div>
  `);
  });

  $(target).parent().append($clonedNode);
};

const initAddContactModal = () => {
  $('#service-add-contact-modal').modal('show');
};

const clearInputs = function (inputs) {
  inputs.each((i, input) => {
    $(input).val('');
  });
};

const submitNewContact = function (e) {
  e.preventDefault();
  $(this).find('.cloned').remove();
  clearInputs($(this).find('input'));
  $('#service-add-contact-modal').modal('hide');
};

const reactOnReview = function () {
  $(this).toggleClass('g-color-green');
};

const renderAnswerOnComment = function (e) {
  e.preventDefault();

  if ($(this).closest('.single-comment').next('.single-answer').length >= 1) {
    $(this).closest('.single-comment').next('.single-answer').toggleClass('d-none');

    return;
  }

  const markup = `
    <div class="single-answer media g-mb-20">
    <img
        class="d-flex g-width-50 g-height-50 rounded-circle g-mr-20 g-mt-4"
        src="/build/img/img-temp/100x100/img14.jpg"
        alt="Image Description"
    >
    <div class="media-body text-right">
      <form class="submit-comment" action="">
        <div class="form-group">
            <textarea
                rows="4"
                class="form-control rounded-0 form-control-md g-box-shadow-1 g-brd-gray-light-v4"
                placeholder="Введите ответ"
            ></textarea>
        </div>
        <button
            class="btn btn-md u-btn-primary rounded-0 g-font-size-14 g-font-weight-600 g-py-10"
            type="submit"
        >Отправить
        </button>
      </form>
    </div>
</div>
  `;

  $(this).closest('.single-comment').after(markup);
};

const toggleLikeBtn = function () {
  if ($(this).hasClass('respond-btn-like')) {
    $(this).closest('form').find('.respond-btn-dislike').removeClass('u-btn-pink g-color-white g-brd-pink');
    $(this).addClass('u-btn-primary g-color-white g-brd-primary');
  }

  if ($(this).hasClass('respond-btn-dislike')) {
    $(this).closest('form').find('.respond-btn-like').removeClass('u-btn-primary g-color-white g-brd-primary');
    $(this).addClass('u-btn-pink g-color-white g-brd-pink');
  }
};

const addNewComment = function () {
  $('#add-new-comment-modal').modal('show');
};

$(document).on('click', '.review-like', reactOnReview);
$(document).on('click', '.add-new-comment', addNewComment);
$(document).on('click', '.answer-on-comment', renderAnswerOnComment);
$(document).on('click', '.respond-btn', toggleLikeBtn);
$('.new-service-stepper').on('click', '.service-add-contact', initAddContactModal);
$('#service-add-contact-modal').on('click', '.copy-btn', cloneNode);
$('#service-add-contact-modal').on('click', '.delete', removeClonedNode);
$('#service-add-contact-modal').on('submit', '.new-contact-form', submitNewContact);

//Блокировка кнопок сабмита до валидации форм и разблокировка после

var ids = '#archive_form,#tender_form,#service_form';
//для архива\тендера\услуги
$(ids).on('ajaxBeforeSend', function (e) {
    $('#'+this.getAttribute('id')).find('#step4Button').prop('disabled', true);
});
$(ids).on('ajaxComplete', function (e) {
    $('#'+this.getAttribute('id')).find('#step4Button').prop('disabled', false);
});
//для техники\контактов\сотрудников
$('#rig_form,#contact_form,#invite_form').on('beforeValidate', function (e) {
    $('#'+this.getAttribute('id')).find('#rig_submit,#contact_submit,#invite_submit').prop('disabled', true);
});
$('#rig_form,#contact_form,#invite_form').on('afterValidate', function (e) {
    $('#'+this.getAttribute('id')).find('#rig_submit,#contact_submit,#invite_submit').prop('disabled', false);
});

$(document).on('beforeValidate', '#contactCreateAjax_form', function (e) {
    console.log('beforeValidate');
    $('#'+this.getAttribute('id')).find('#contact_submit').prop('disabled', true);
});



if (document.querySelector('#js-map')) {
  ymaps.ready(init);
}

